import React from 'react';

const ML_Terminology = () => {
    return (
        <div>ML_Terminology Component</div>
    );
}

export default ML_Terminology;
